import { cloneSubschemaConfig } from '@graphql-tools/delegate';
export function splitMergedTypeEntryPointsTransformer(subschemaConfig) {
    if (!subschemaConfig.merge)
        return [subschemaConfig];
    var maxEntryPoints = Object.values(subschemaConfig.merge).reduce(function (max, mergedTypeConfig) {
        var _a, _b;
        return Math.max(max, (_b = (_a = mergedTypeConfig === null || mergedTypeConfig === void 0 ? void 0 : mergedTypeConfig.entryPoints) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0);
    }, 0);
    if (maxEntryPoints === 0)
        return [subschemaConfig];
    var subschemaPermutations = [];
    var _loop_1 = function (i) {
        var subschemaPermutation = cloneSubschemaConfig(subschemaConfig);
        var mergedTypesCopy = subschemaPermutation.merge;
        if (i > 0) {
            subschemaPermutation.merge = Object.create(null);
        }
        Object.keys(mergedTypesCopy).forEach(function (typeName) {
            var _a, _b, _c;
            var mergedTypeConfig = mergedTypesCopy[typeName];
            var mergedTypeEntryPoint = (_a = mergedTypeConfig === null || mergedTypeConfig === void 0 ? void 0 : mergedTypeConfig.entryPoints) === null || _a === void 0 ? void 0 : _a[i];
            if (mergedTypeEntryPoint) {
                if ((_c = (_b = mergedTypeConfig.selectionSet) !== null && _b !== void 0 ? _b : mergedTypeConfig.fieldName) !== null && _c !== void 0 ? _c : mergedTypeConfig.resolve) {
                    throw new Error("Merged type " + typeName + " may not define entryPoints in addition to selectionSet, fieldName, or resolve");
                }
                Object.assign(mergedTypeConfig, mergedTypeEntryPoint);
                delete mergedTypeConfig.entryPoints;
                if (i > 0) {
                    delete mergedTypeConfig.canonical;
                    if (mergedTypeConfig.fields != null) {
                        Object.values(mergedTypeConfig.fields).forEach(function (mergedFieldConfig) {
                            delete mergedFieldConfig.canonical;
                        });
                    }
                }
                subschemaPermutation.merge[typeName] = mergedTypeConfig;
            }
        });
        subschemaPermutations.push(subschemaPermutation);
    };
    for (var i = 0; i < maxEntryPoints; i += 1) {
        _loop_1(i);
    }
    return subschemaPermutations;
}
//# sourceMappingURL=splitMergedTypeEntryPointsTransformer.js.map